import { useState } from "react";
import { forgotPasswordApi } from "../../api/auth.api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPasswordApi(email);
      toast.success("OTP sent to your email");
      navigate("/reset-password", { state: { email } });
    } catch (err) {
      toast.error(err.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-card">
      <h1 className="auth-title">Forgot Password</h1>
      <p className="auth-muted">
        Enter your registered email to receive an OTP.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="auth-field">
          <input
            type="email"
            required
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="auth-input no-extra-padding"
          />
        </div>

        <button type="submit" disabled={loading} className="auth-btn">
          {loading ? "Sending OTP..." : "Send OTP"}
        </button>

        <p className="auth-footer">
          Want to go back?
          <Link to="/login" className="auth-link">
            Login
          </Link>
        </p>
      </form>
    </div>
  );
}
